module.exports = __webpack_public_path__ + "img/5.34dddca3.jpg";